import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { machineProfile } from "../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext.jsx";
import {
  dateToToday,
  formatDateOnly,
  generateLocationToArray,
  printLocation,
} from "../../utils/helper.jsx";
import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import { MachineProfile } from "../../api/machine_profile.js";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";
import { Loader } from "../../utils/helper";
import DataTable from "react-data-table-component";
import { LocationFilter } from "../../components/LocationFilter/index.jsx";
import ImageViewer from "../../components/ImageViewer";
import { staticDemo } from "../../data/formatted_demo.js";
import SideBarLocation from "../../components/SideBarLocation";

function MachineList() {
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState({ company: true });
  const { config, email } = useAuth();
  const { machineTypes } = useDashboardContext();
  const [deleteRow, setDeleteRow] = useState(null);
  const [changeStatus, setChangeStatus] = useState(null);
  const { updateMachineProfile } = useAuth();
  const canUpdate = updateMachineProfile();
  const navigate = useNavigate();

  async function getMachine() {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
      };
      function groupByMN(data) {
        const map = new Map()

        for (const item of data) {
          if (!map.has(item.MN)) {
            map.set(item.MN, {
              C: item.C,
              P: item.P,
              Z: item.Z,
              MN: item.MN,
              MT: item.MT,
              MH: item.MH,
              ME: []
            })
          }

          map.get(item.MN).ME.push({
            name: item.ME,
            SN: item.SN
          })
        }
        return Array.from(map.values())
      }

      if (email === 'admin_cp@groundup.ai') {
        const data = staticDemo.map((item) => ({
          id: item.MN,
          machine_name: item.MN,
          location_id: item.Z,
          location_nodes: [],
          machine_status: "Operational",
          machine_type: {
            name: item.MT,
          },
          MachineHealth: [
            {
              status: item.MH,
              description: `Machine is behaving at an ${item.MH} condition`,
              created_at: new Date(),
              created_by: " ",
            },
          ],
          machine_elements: item.ME.map((me) => ({
            machine_element_name: me.name,
            deployments: [
              {
                "deployed_on": "2024-06-20T09:03:15.107Z",
                "sensor_id": item.SN,
                "sensor": {
                  "internal_id": item.SN,
                  "sensor_serial_number": item.SN,
                  "type": "SVT",
                  "version": "WS21M",
                  "sensor_uptime": [
                    {
                      "id": 40356,
                      "sensor_serial_number": item.SN,
                      "event_time": new Date().toISOString(),
                      "on_off_status": "true",
                      // now for date 10 minutes ago
                      "start_date": new Date().toISOString(),
                      "sensor_id": item.SN,
                      "notified": null,
                      "gateway_id": item.GW,
                      //battery random 95.00 - 99.99 with two commas dont use Math.floor
                      "battery_percentage": parseFloat(Math.random() * (98.99 - 95.00 + 1) + 95.00).toFixed(2)
                    }
                  ]
                }
              }
            ],
            SN: me.SN
          })),
          location: {
            id: item.Z,
            location_name: item.Z,
            parent_location_id: item.P,
            parent_location: {
              id: item.P,
              location_name: item.P,
              parent_location_id: item.C,
              parent_location: {
                id: item.C,
                location_name: item.C,
                parent_location_id: null,
                parent_location: null,
              },
            },
          },
          childMachines: [],
        }));
        data.forEach((d) => {
          const locationNameArr = [];
          generateLocationToArray(d.location, locationNameArr);
          d.location_arr = locationNameArr.reverse();
        });
        setDatas(data);
      } else {
        const res = await machineProfile.list(queryParam);
        if (res.ok) {
          const body = await res.json();
          let data = body.data;
          if (data) {
            data.forEach((d) => {
              const locationNameArr = [];
              generateLocationToArray(d.location, locationNameArr);
              d.location_arr = locationNameArr.reverse();
            });
            setDatas(data);
          }
        }
      }

      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  function changeOperation(value) {
    openChangeStatus(value);
  }

  function generateLocationWording() {
    let result = [];
    if (config && config?.location_wording) {
      const words = config?.location_wording.split(",");
      words.forEach((ln, index) => {
        result.push(ln);
      });
    }

    return result;
  }

  const ExpandedComponent = ({ data }) => {
    return (
      <div style={{ padding: "10px" }}>
        <Card className="border-theme">
          <CardBody>
            <div className={"row"}>
              <div className="col-md-3">
                <ImageViewer src={data?.attachments?.filePhoto}></ImageViewer>
              </div>
              <div className="col-md-9">
                <div>
                  Machine Name : <b>{data.machine_name}</b>
                </div>
                <hr />
                {data?.machine_status === "Operational" ? (
                  <div className="mb-2">
                    <table>
                      <thead>
                        <tr>
                          <th colSpan={3}>Sensor Online Status</th>
                          <th>Battery Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.machine_elements.map((cm, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                width: "100px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {" "}
                              {cm.machine_element_name}
                            </td>
                            <td>
                              <i className="fa fa-chevron-right"></i>
                            </td>
                            <td style={{ padding: "0 5px" }}>
                              {email?.includes("demokit") ? (
                                <span
                                  style={{
                                    padding: "1px 15px 1px 15px",
                                    color: "#040930",
                                    background: "#71c56b",
                                  }}
                                >
                                  Online
                                </span>
                              ) : (
                                <span
                                  className={`custom-chip tableFontSize ${cm.deployments[0]?.sensor?.sensor_uptime[0]
                                    ?.on_off_status === "true"
                                    ? "chip-green"
                                    : "chip-red"
                                    }`}
                                  style={{
                                    padding: "1px 15px 1px 15px",
                                    color: "#040930",
                                    background:
                                      cm.deployments[0]?.sensor?.sensor_uptime[0]
                                        ?.on_off_status === "true"
                                        ? "#71c56b"
                                        : "#ff8c87",
                                    fontSize: "11px",
                                  }}
                                >
                                  {cm.deployments[0]?.sensor?.sensor_uptime[0]
                                    ?.on_off_status === "true"
                                    ? "Online"
                                    : "Offline"}
                                </span>
                              )}
                            </td>
                            <td style={{ padding: "0 5px" }}>
                              {renderBatteryPercentage(cm.deployments[0]?.sensor?.sensor_uptime[0]?.battery_percentage)}
                            </td>
                            <td>
                              {cm.deployments[0]?.sensor?.sensor_uptime[0]
                                ?.on_off_status === "true" ? null : (
                                <div>
                                  <div style={{ fontSize: "10px" }}>
                                    Last Active
                                  </div>
                                  <div style={{ fontSize: "12px" }}>
                                    {formatDateOnly(
                                      cm.deployments[0]?.sensor?.sensor_uptime[0]
                                        ?.start_date
                                    )}
                                  </div>
                                </div>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="mt-3 mb-3 text-underline">
                    <h4>
                      {" "}
                      <b>- In {data?.machine_status} Status -</b>
                    </h4>
                  </div>
                )}

                <button
                  style={{ marginRight: "10px" }}
                  onClick={() => {

                    if (email?.includes("admin_cp")) {
                      if (data.MH === 'Observe') {
                        navigate("/machine/ed7f80f3-59f9-4b5a-8231-b02acf098c4b")
                      } else {
                        navigate("/machine/f65fb467-4eef-450c-a465-125c17cf5d81")
                      }
                    } else {
                      navigate("/machine/" + data.id)
                    }
                  }}
                  type="button"
                  className="btn btn-outline-theme"
                >
                  Machine Profile
                </button>

                <button
                  onClick={() => {
                    if (email.includes("admin_cp")) {
                      if (data.MH === 'Observe') {
                        navigate("/sensor/live/ed7f80f3-59f9-4b5a-8231-b02acf098c4b")
                      } else {
                        navigate("/sensor/live/f65fb467-4eef-450c-a465-125c17cf5d81")
                      }
                    } else {
                      navigate("/sensor/live/" + data.id)
                    }

                  }}
                  style={{ marginRight: "10px" }}
                  type="button"
                  className="btn btn-outline-theme"
                >
                  View Live Sensor Data
                </button>
                {canUpdate && (
                  <button
                    onClick={() => navigate("/machine/edit/" + data.id)}
                    type="button"
                    style={{ marginRight: "10px" }}
                    className="btn btn-outline-theme"
                  >
                    <i className="fa fa-edit"></i> Edit machine
                  </button>
                )}
                {canUpdate && (
                  <button
                    onClick={() => {
                      changeOperation(data);
                    }}
                    type="button"
                    className="btn btn-outline-theme"
                  >
                    <i className="fa fa-edit"></i> Change Operation Status
                  </button>
                )}
              </div>
            </div>
          </CardBody>
        </Card>
      </div>
    );
  };

  function showConfirmationDlg(row) {
    setDeleteRow(row);
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
  }

  function openChangeStatus(value) {
    setChangeStatus(value);
  }

  function hideChangeStatus() {
    setChangeStatus(null);
  }

  function countOnlineOffline(machine) {
    let online = 0;
    let offline = 0;
    machine.machine_elements.forEach((cm) => {
      if (
        cm.deployments[0]?.sensor?.sensor_uptime[0]?.on_off_status === "true"
      ) {
        online++;
      } else {
        offline++;
      }
    });
    return { online, offline };
  }

  async function deleteMachinProfile() {
    try {
      const response = await MachineProfile.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("This machine profile has been deleted");

          setDeleteRow(null);
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  function getBatteryEl(el, color, customStyles) {
    const colors = {
      'green': '#71c56b',
      'yellow': '#ffb84d',
      'red': '#ff8c87',
    }
    let styles = {
      padding: "1px 15px 1px 15px",
      color: "#040930",
      background: colors[color],
      fontSize: "11px",
    }
    if (customStyles) {
      styles = {
        ...styles,
        ...customStyles,
      }
    }
    return <span
      className="custom-chip tableFontSize"
      style={styles}
    >
      {el}
    </span>
  }

  function renderBatteryPercentage(battery) {
    if (email?.includes("demokit")) {
      return getBatteryEl(<>95%</>, 'green')
    }
    if (battery === null || battery === undefined) {
      return (
        <div className="mt-3 mb-3 text-underline">
          <span>
            {" "}
            <b>- No Battery Data -</b>
          </span>
        </div>
      )
    }

    if (battery >= 65 && battery <= 150) {
      return getBatteryEl(<>{battery}%</>, 'green')
    } else if (battery >= 50 && battery <= 64) {
      return getBatteryEl(<>{battery}%</>, 'yellow')
    } else if (battery >= 0 && battery <= 50) {
      return getBatteryEl(<>{battery}%</>, 'red')
    }
  }

  function renderBatteryStatus(machine) {
    let good = 0
    let poor = 0
    let noData = 0
    machine.machine_elements.forEach((cm) => {
      const battery = cm.deployments[0]?.sensor?.sensor_uptime[0]?.battery_percentage
      if (battery === null || battery === undefined) {
        noData++
      } else if (battery >= 65 && battery <= 150) {
        good++
      } else if (battery <= 64) {
        poor++
      }
    })

    const elements = []

    const customStyles = {
      fontSize: "13px",
    }

    if (noData > 0) {
      elements.push(
        <div className="mt-3 mb-3 text-underline">
          <span>
            {" "}
            <b>- No Battery Data -</b>
          </span>
        </div>
      )
    } else {
      if ((poor === 0 || good === 0)) {
        if (good === 0) {
          elements.push(getBatteryEl(<>All Poor</>, 'red', customStyles))
        }
        if (poor === 0) {
          elements.push(getBatteryEl(<>All Good</>, 'green', customStyles))
        }
      } else {
        if (good > 0) {
          elements.push(getBatteryEl(<>{good} Good</>, 'green', customStyles))
        }

        if (poor > 0) {
          elements.push(getBatteryEl(<>{poor} Poor</>, 'red', customStyles))
        }
      }
    }

    return elements.length > 0 ? (
      <div style={{ display: 'flex', gap: '5px', flexWrap: 'wrap' }}>
        {elements}
      </div>
    ) : null
  }

  const columns = [
    ...generateLocationWording().map((w, i) => ({
      name: w,
      grow: 1,
      selector: (row) => printLocation(row.location_arr[i]),
    })),
    {
      name: "Machine Name",
      selector: (row) => row.machine_name,
      minWidth: "250px",
    },
    {
      name: "Machine Type",
      selector: (row) => row.machine_type.name,
    },
    {
      name: "Sensor Online Status",
      minWidth: "200px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => email?.includes("demokit") ? (
        <div>
          <span
            style={{
              padding: "1px 15px 1px 15px",
              color: "#040930",
              background: "#71c56b",
            }}
          >
            All Online
          </span>

        </div>
      ) : (
        <div>
          {row.machine_status === "Operational" ? (
            <div>
              {countOnlineOffline(row).offline === 0 ? (
                <span
                  style={{
                    padding: "1px 15px 1px 15px",
                    color: "#040930",
                    background: "#71c56b",
                  }}
                >
                  All Online
                </span>
              ) : (
                <>
                  <span
                    style={{
                      padding: "1px 15px 1px 15px",
                      color: "#040930",
                      background: "#71c56b",
                    }}
                  >
                    {countOnlineOffline(row).online} Online
                  </span>{" "}
                  -
                  <span
                    style={{
                      padding: "1px 15px 1px 15px",
                      color: "#040930",
                      background: "#ff8c87",
                    }}
                  >
                    {countOnlineOffline(row).offline} Offline
                  </span>
                </>
              )}
            </div>
          ) : (
            <div className="text-underline">
              <b>- In {row?.machine_status} Status -</b>
            </div>
          )}
        </div>
      ),
    },
    {
      name: "Battery Status",
      minWidth: "200px",
      style: {
        paddingRight: "0",
      },
      cell: (row) => email?.includes("demokit") ? (
        <div>
          <span
            style={{

              padding: "1px 15px 1px 15px",
              color: "#040930",
              background: "#71c56b",
            }}
          >
            All Good
          </span>

        </div>
      ) : (
        <div>
          {row.machine_status === "Operational" ? (
            <div>
              {renderBatteryStatus(row)}
            </div>
          ) : (
            <div className="text-underline">
              <b>- In {row?.machine_status} Status -</b>
            </div>
          )}
        </div>
      )
    }
  ];

  const handleChangeLocationFilter = (location_id) => {
    setQuery((prev) => ({
      ...prev,
      location_id: location_id ? location_id : "",
    }));
  };

  const handleChangeMachineType = (machine_type_id) => {
    setQuery((prev) => ({
      ...prev,
      machine_type_id: machine_type_id,
    }));
  };

  useEffect(() => {
    getMachine();
    // eslint-disable-next-line
  }, [query]);

  const onChangeStatus = (e) => {
    setChangeStatus((prev) => ({
      ...prev,
      machine_status: e.target.value,
    }));
  };

  const prosesChangeStatus = async () => {
    try {
      const response = await machineProfile.updateStatus(
        changeStatus.id,
        changeStatus.machine_status
      );
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("Machine Status has been changed");

          setChangeStatus(null);
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">


          <div id="datatable" className="mb-5">
            <div className="row mb-2 justify-content-sm-end">
              <div className="col-sm-3 mb-2 mb-sm-0">
                <LocationFilter onChange={handleChangeLocationFilter} />
              </div>
              <div className="col-sm-3 mb-2 mb-sm-0">
                <select
                  className="form-select btn btn-outline-theme"
                  defaultValue=""
                  onChange={(e) => {
                    handleChangeMachineType(e.target.value);
                  }}
                >
                  <option value="">- Machine Type -</option>
                  {machineTypes.map((mt) => (
                    <option key={mt.id} value={mt.id}>
                      {mt.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-sm-3 mb-2 mb-sm-0">
                <button
                  onClick={() => {
                    navigate("/machine/add");
                  }}
                  className="btn btn-outline-theme w-100"
                >
                  Add Machine <i className="bi bi-plus"></i>
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody>
                    <Loader loading={loading}>
                      <DataTable
                        highlightOnHover
                        expandOnRowClicked
                        expandableRowsHideExpander
                        expandableRows
                        expandableRowsComponent={ExpandedComponent}
                        theme="dark"
                        columns={columns}
                        data={datas}
                        pagination
                      />
                    </Loader>
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteRow && (
        <ConfirmationDlg
          title={"Delete Machine Profile"}
          open={!!deleteRow}
          onClose={hideConfirmationDialog}
          onSubmit={deleteMachinProfile}
        >
          <p style={{ pb: 2 }}>
            Are you sure you want to delete this Machine Profile{" "}
            <strong>{deleteRow.machine_name}</strong> ?
          </p>
        </ConfirmationDlg>
      )}
      {changeStatus && (
        <ConfirmationDlg
          title={"Change Machine Status"}
          open={!!changeStatus}
          onClose={hideChangeStatus}
          btnSubmitText={"Update"}
          btnCancelText={"Cancel"}
          onSubmit={prosesChangeStatus}
        >
          <p style={{ pb: 2 }}>
            Change Status of <strong>{changeStatus.machine_name}</strong> ?
          </p>
          <div className="form-group">
            <select
              className={"form-select "}
              value={changeStatus?.machine_status}
              onChange={onChangeStatus}
            >
              <option value="Operational">Operational</option>
              <option value="Maintenance">Maintenance</option>
              <option value="Repair">Repair</option>
              <option value="Archived">Archived</option>
            </select>
          </div>
        </ConfirmationDlg>
      )}
    </div>
  );
}

export default MachineList;
